//Include Both Helper File with needed methods

import { set_add_on_plan_details, set_billing_details, set_current_plan_details, set_current_plan_type, set_default_payment_method, set_payment_method, set_payment_summary_failed, set_plan_features, set_Plans, set_Plans_Failed, start_Plan_loading, stop_plan_loading } from "./reducer";
import { add_payment_methods, billing_info, fetch_payment_method, fetch_plan_details, fetch_plan_summary, fetch_Plans, get_current_plan_add_on_detaitls, purchase_add_on, start_plan_buying } from "../../helpers/fakebackend_helper";



export const Get_Plans = (user,navigate) => async (dispatch) => {



  try {
    
    dispatch(start_Plan_loading())

    let response = fetch_Plans()

    const api_response = await response

    dispatch(set_Plans(api_response))


   
  } catch (error) {
    console.log("Error" , error);
    
    dispatch(set_Plans_Failed(error));
  }
};



export const Start_Check_Out = (filterData) => async (dispatch)=>{

  try {

    dispatch(start_Plan_loading())
    let response = start_plan_buying({type_:'subscription' , plan_id:filterData.plan_id , plan:filterData.plan_type})
    
    const api_resposne = await response

    window.location.href = api_resposne.redirect
    

    dispatch(stop_plan_loading())


  } catch (error) {

    
    dispatch(set_Plans_Failed(error));
  }

}


export const get_payment_summary = (filterData) => async (dispatch)=>{

  try {

    dispatch(start_Plan_loading())
    let resposne  = fetch_plan_summary()
    const api_resposne = await resposne
    if(api_resposne.plan){
      dispatch(set_current_plan_details(api_resposne.plan))

    }

    
  } catch (error) {

    
    dispatch(set_payment_summary_failed(error));
  }

}

//billing_info



export const get_billings = (filterData) => async (dispatch)=>{

  try {

    dispatch(start_Plan_loading())
    let resposne  = billing_info(filterData)
    const api_resposne = await resposne

    dispatch(set_billing_details(api_resposne.paymentlogs))
    
  } catch (error) {

    
    dispatch(set_Plans_Failed(error));
  }

}


export const  Fetch_Payment_Methods = (filterData) => async (dispatch)=>{
      
  try {

    dispatch(start_Plan_loading())
    let resposne  = fetch_payment_method()
    const api_resposne = await resposne

    dispatch(set_payment_method(api_resposne.subscription.available_payment_methods))
    dispatch(set_default_payment_method(api_resposne.subscription.live_details.default_payment_method))
    console.log(api_resposne.subscription, "Payment  Methods");
    
    dispatch(set_current_plan_type(api_resposne.subscription.live_details.metadata.subscription_type))
    
  } catch (error) {

    
    dispatch(set_Plans_Failed(error));
  }

}




export const Add_Payment_Method = (filterData) => async (dispatch)=>{

  try {

    dispatch(start_Plan_loading())
    let response = add_payment_methods(filterData)
    
    const api_resposne = await response

    window.location.href = api_resposne.redirectulr
    

    dispatch(stop_plan_loading())


  } catch (error) {

    
    dispatch(set_Plans_Failed(error));
  }

}



export const Purchase_Add_On = (filterData) => async (dispatch)=>{

  try {

       
    dispatch(start_Plan_loading())
    let response = purchase_add_on(filterData)
    
    
    const api_resposne = await response


    window.location.href = api_resposne.redirect
    

    dispatch(stop_plan_loading())


  } catch (error) {

    console.log(error)
    dispatch(set_Plans_Failed(error));
  }

}


export const Get_Add_On_Details = (filterData) => async (dispatch)=>{

  try {

    dispatch(start_Plan_loading())
    let response = get_current_plan_add_on_detaitls()
    
    const api_resposne = await response
    dispatch(set_add_on_plan_details(api_resposne))

  } catch (error) {

    
    dispatch(set_Plans_Failed(error));
  }

}



export const Get_Plan_Allowed_Features = (filterData) => async (dispatch)=>{
  try {

    dispatch(start_Plan_loading())
    let response = fetch_plan_details()
    
    const api_resposne = await response
    dispatch(set_plan_features(api_resposne))

  } catch (error) {

    
    dispatch(set_Plans_Failed(error));
  }

}